import { render, staticRenderFns } from "./SmallView.vue?vue&type=template&id=4d6d26ca&"
import script from "./SmallView.vue?vue&type=script&lang=js&"
export * from "./SmallView.vue?vue&type=script&lang=js&"
import style0 from "./uservideo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6d26ca')) {
      api.createRecord('4d6d26ca', component.options)
    } else {
      api.reload('4d6d26ca', component.options)
    }
    module.hot.accept("./SmallView.vue?vue&type=template&id=4d6d26ca&", function () {
      api.rerender('4d6d26ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/userVideo/SmallView.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/userVideo/SmallView.vue
// module id = AI4i
// module chunks = 0